/**
 * Campos de auth expuestos vía contexto.
 * Credenciales, tokens internos y flags de flujo no se incluyen aquí.
 */
export function selectPublicAuthState (state) {
  return {
    loginStatus: state.loginStatus,
    isFailedLogin: state.isFailedLogin,
    isAuthenticated: state.isAuthenticated,
    isInitialized: state.isInitialized,
    isSessionExpired: state.isSessionExpired,
    authNotice: state.authNotice,
    sessionsData: state.sessionsData,
    closeSessionsStatus: state.closeSessionsStatus,
    fbData: state.fbData,
    fbFailed: state.fbFailed,
    userData: state.userData,
  }
}

export const publicAuthStateDefaults = selectPublicAuthState({
  loginStatus: null,
  isFailedLogin: false,
  isAuthenticated: false,
  isInitialized: false,
  isSessionExpired: false,
  authNotice: null,
  sessionsData: null,
  closeSessionsStatus: true,
  fbData: null,
  fbFailed: null,
  userData: null,
})
